// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-5815817f] .el-dialog {\n  max-width: 1500px;\n}\n[data-v-5815817f] .el-dialog__body {\n  padding-top: 15px;\n}", ""]);
// Exports
module.exports = exports;
